import { render, staticRenderFns } from "./LeadlikeSms.vue?vue&type=template&id=075bdef8&scoped=true&"
import script from "./LeadlikeSms.vue?vue&type=script&lang=js&"
export * from "./LeadlikeSms.vue?vue&type=script&lang=js&"
import style0 from "./LeadlikeSms.vue?vue&type=style&index=0&id=075bdef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075bdef8",
  null
  
)

export default component.exports